import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { TableDatasource } from '@gamelearn/skeletor/models';
import { StoreService, CsvService, UtilsService } from 'core/services';
import { Subscription } from 'rxjs';

// TODO this component maintains compatibility with admin tables and skeletor tables using the "skeletor" attribute, delete when not needed
@Component({
  selector: 'lms-csv-download',
  templateUrl: './csv-download.component.html',
  styleUrls: ['./csv-download.component.scss']
})
export class CsvDownloadComponent implements OnInit, OnDestroy {
  public list: any[];
  @Input() listId: string;
  @Input() fieldNames: any;
  @Input() skeletor: boolean = false; // TODO flag to maintain compatibility true for skeletor table false for admin old ones
  @Input() customDowload: boolean = false;
  @Output() onDownload: EventEmitter<any> = new EventEmitter();
  private tableDatasource: TableDatasource;
  public listSubscription: Subscription;

  constructor(public csvService: CsvService) {}

  ngOnInit() {
    StoreService.get(this.listId + '_DOCS').subscribe((data) => {
      if (data && data.length > 0) {
        this.list = data;
      }
    });
    this.listSubscription = StoreService.get(this.listId).subscribe((data) => {
      if (this.skeletor) {
        this.tableDatasource = data;
      }
    });
  }

  ngOnDestroy() {
    this.listSubscription.unsubscribe();
  }

  downloadCSV() {
    if (this.customDowload) {
      this.onDownload.emit();
    } else {
      if (this.skeletor) {
        this.downloadSkeletorCSV();
      } else {
        this.downloadAdminTableCSV();
      }
    }
  }

  private downloadSkeletorCSV() {
    if (!this.tableDatasource?.docs.length) {
      return;
    }

    const headers = this.tableDatasource.columns
      .filter((column) => column.source && column.visible)
      .map((column) => column.label || column.source);

    const rows = this.tableDatasource.docs.map((record) => {
      const row = {};
      this.tableDatasource.columns.forEach((column) => {
        if (column.source && column.visible) {
          const value = column.parseValue(record);
          const columnName = column.label || column.source;
          // eslint-disable-next-line
          row[columnName] = typeof value === 'object' ? JSON.stringify(value) : value;
        }
      });
      return row;
    });

    this.csvService.dataToCsv(rows, 'csvFile', {
      showLabels: true,
      headers
    });
  }

  private downloadAdminTableCSV() {
    const rows = this.list.map((record) => {
      const newRecord = {};
      this.fieldNames.forEach((fieldName) => {
        newRecord[fieldName] = UtilsService.getDeepValue(record, fieldName);
      });
      return newRecord;
    });
    this.csvService.dataToCsv(rows, 'csvFile', {
      showLabels: true,
      headers: Object.keys(rows[0])
    });
  }
}
